module.exports = __webpack_public_path__ + "img/homes_step3.d89dfe50.svg";